import React from 'react'
import clsx from 'clsx'

type StatColor = 'primary' | 'accent' | 'warning' | 'info' | 'success' | 'error'

interface StatCardProps {
  number: number | string
  label: string
  color?: StatColor
  icon?: React.ReactNode
  className?: string
}

const colorStyles: Record<StatColor, { bg: string; text: string; icon: string }> = {
  primary: { bg: 'bg-primary/10', text: 'text-primary', icon: 'text-primary' },
  accent: { bg: 'bg-accent/10', text: 'text-accent', icon: 'text-accent' },
  warning: { bg: 'bg-warning/10', text: 'text-warning', icon: 'text-warning' },
  info: { bg: 'bg-info/10', text: 'text-info', icon: 'text-info' },
  success: { bg: 'bg-success/10', text: 'text-success', icon: 'text-success' },
  error: { bg: 'bg-error/10', text: 'text-error', icon: 'text-error' },
}

export default function StatCard({ number, label, color = 'primary', icon, className }: StatCardProps) {
  const styles = colorStyles[color]
  return (
    <div className={clsx('bg-iswara-card rounded-card shadow-card p-4 flex items-center gap-3', className)}>
      {icon && (
        <div className={clsx('w-12 h-12 rounded-full flex items-center justify-center', styles.bg)}>
          <div className={styles.icon}>{icon}</div>
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className={clsx('text-2xl font-bold', styles.text)}>{number}</p>
        <p className="text-xs text-text-secondary truncate">{label}</p>
      </div>
    </div>
  )
}
